var _mask, _mask2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 27,
    viewBox: "0 0 45 27",
    width: 45,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.8034934.10431818h-44.8034934v13.32466652 13.3246666h44.8034934z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 26.8956818h44.8484934v-26.72035712h-44.8484934z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.8034934 24.0887162c0 1.4718507-1.3374235 2.6649351-2.9868995 2.6649351h-38.82969434c-1.64947598 0-2.98689956-1.1930844-2.98689956-2.6649351v-21.31948049c0-1.47185065 1.33742358-2.66493506 2.98689956-2.66493506h38.82969434c1.649476 0 2.9868995 1.19308441 2.9868995 2.66493506z",
    fill: "#ebedee",
    mask: "url(#a)",
    transform: "translate(0 .071006)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.9061812 26.8246753c1.6496725 0 2.8972926-1.0544026 2.8972926-2.5262532v-7.8680455s-11.4679258 7.2384546-32.6356114 10.3942987z",
    fill: "#e67e22"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.8483952 16.4303591s-11.5129258 7.309461-32.6806114 10.4653052c25.25738 0 32.6806114-10.4653052 32.6806114-10.4653052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.20703275 12.391387c-.38338428.3089221-.88133188.4435714-1.66971616.4435714h-.32737991v-3.69023372h.32737991c.78838428 0 1.26668123.12570779 1.66971616.45128571.42189956.33522078.67558952.85470781.67558952 1.38909741 0 .5359675-.25368996 1.0712338-.67558952 1.4062792m-1.42526201-4.19236362h-1.7909607v5.58075972h1.78152839c.94735808 0 1.63120087-.1993441 2.23172489-.6443182.71351528-.5268506 1.13541485-1.3208961 1.13541485-2.1421168 0-1.64700005-1.37927948-2.79432472-3.35770743-2.79432472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.70091703 13.7798182h1.21991266v-5.58075976h-1.21991266z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.9041921 10.3406494c-.7321834-.2417728-.946965-.40114291-.946965-.70270135 0-.35152597.3829912-.61854545.9088428-.61854545.3655022 0 .6659607.13412337.9837118.45198701l.6384497-.74583117c-.5244759-.40938312-1.1523144-.61872078-1.8379257-.61872078-1.1067249 0-1.9509171.68569481-1.9509171 1.59913637 0 .76879867.3930131 1.16240257 1.5388428 1.53023377.4777075.1504286.7207861.250539.8434062.3178636.2438646.142013.3658952.3431104.3658952.5775195 0 .4521623-.403035.7872078-.9473581.7872078-.5818559 0-1.050524-.2596558-1.3315284-.7444286l-.7881878.6771039c.5622053.7363637 1.2372053 1.0624676 2.1656987 1.0624676 1.2676638 0 2.1570524-.7519676 2.1570524-1.8323182 0-.8867922-.4112882-1.2881104-1.7990175-1.740974",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.0882052 10.9933305c0 1.6403377 1.4437337 2.9123182 3.3015066 2.9123182.525262 0 .9750655-.0922208 1.529607-.3252273v-1.281448c-.4875328.4355065-.9198472.6111818-1.4728166.6111818-1.2287555 0-2.1010481-.7947468-2.1010481-1.9248896 0-1.07140911.9-1.91664937 2.0442577-1.91664937.5820524 0 1.0224236.18531819 1.529607.62801299v-1.28092208c-.5356769-.2422987-.9758516-.34275974-1.5009171-.34275974-1.8483406 0-3.3301965 1.29775325-3.3301965 2.9203831",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.5930415 11.9476753-1.6679476-3.74861686h-1.3329039l2.6544104 5.72382466h.6565284l2.7021616-5.72382466h-1.3224891z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.1570218 13.7797831h3.4598909v-.9448247h-2.2407642v-1.5062142h2.1582314v-.9453507h-2.1582314v-1.23866882h2.2407642v-.9457013h-3.4598909z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.0000262 10.7683539h-.3562664v-1.6903052h.3757205c.7598909 0 1.1727511.28402598 1.1727511.82735714 0 .56086366-.4128602.86294806-1.1922052.86294806m2.4476856-.92168182c0-1.04475974-.8064629-1.64752598-2.2136463-1.64752598h-1.8090393v5.5805844h1.2187336v-2.2417013h.1589738l1.6887773 2.2417013h1.500524l-1.9691921-2.3509286c.9190611-.166909 1.424869-.7275974 1.424869-1.58212982",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m26.9726266 11.0087416c0 1.6396363-1.4897161 2.968948-3.3274454 2.968948-1.8379257 0-3.3274454-1.3293117-3.3274454-2.968948 0-1.63981173 1.4895197-2.96859744 3.3274454-2.96859744 1.8377293 0 3.3274454 1.32878571 3.3274454 2.96859744",
    fill: "#e67e22",
    mask: "url(#b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.df069815b025d3e53648047518729669.svg";
export { ForwardRef as ReactComponent };